import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalFormString, optionalFormTrimmedString, requiredEnumIdString, } from '../zod-helpers/index.js';
import { ADDRESS_CONSTRAINTS } from './constraints.js';
const requiredFormPart = (label, maxLength) => z.string().trim().min(1, `${label} is required.`).max(maxLength);
/** Mirrors addressPartSchemas, in the form shape where a blank field arrives as ''. */
export function addressFormPartFields({ requireFullAddress = false, } = {}) {
    if (!requireFullAddress) {
        return {
            city: optionalFormTrimmedString(ADDRESS_CONSTRAINTS.city.maxLength),
            stateId: optionalFormString(),
            countryId: optionalFormString(),
            zip: optionalFormTrimmedString(ADDRESS_CONSTRAINTS.zip.maxLength),
        };
    }
    return {
        city: requiredFormPart(ADDRESS_CONSTRAINTS.city.label, ADDRESS_CONSTRAINTS.city.maxLength),
        stateId: z.string().trim().min(1, 'State is required.'),
        countryId: z.string().trim().min(1, 'Country is required.'),
        zip: requiredFormPart(ADDRESS_CONSTRAINTS.zip.label, ADDRESS_CONSTRAINTS.zip.maxLength),
    };
}
const addressLocationBaseFields = {
    addressName: z
        .string()
        .trim()
        .min(1, `${capitalize(ADDRESS_CONSTRAINTS.addressName.label.toLowerCase())} is required.`)
        .max(ADDRESS_CONSTRAINTS.addressName.maxLength),
    address: z
        .string()
        .trim()
        .min(1, `${capitalize(ADDRESS_CONSTRAINTS.address.label.toLowerCase())} is required.`)
        .max(ADDRESS_CONSTRAINTS.address.maxLength),
};
const addressLocationFormFields = {
    ...addressLocationBaseFields,
    ...addressFormPartFields(),
};
export const addressLocationFormSchema = z.object(addressLocationFormFields);
export const EMPTY_ADDRESS_LOCATION_FORM = {
    addressName: '',
    address: '',
    city: '',
    stateId: '',
    countryId: '',
    zip: '',
};
export function buildAddressFormSchema(allowedTypes, invalidTypeMessage = 'Invalid address type.', strictness = {}) {
    return z.object({
        ...addressLocationBaseFields,
        ...addressFormPartFields(strictness),
        typeId: requiredEnumIdString(allowedTypes, `${capitalize(ADDRESS_CONSTRAINTS.typeId.label.toLowerCase())} is required.`, invalidTypeMessage),
        defaultFlag: z.boolean().optional(),
    });
}
export const EMPTY_ADDRESS_FORM = {
    ...EMPTY_ADDRESS_LOCATION_FORM,
    typeId: '',
    defaultFlag: false,
};
//# sourceMappingURL=create-form.js.map